import type { FC, ReactNode } from 'react'

import { FileCheck2 } from 'lucide-react'
import { STANDARDS } from '@/constants/content'

export const StandardsStrip: FC = (): ReactNode => {
    return (
        <section
            id='normen'
            aria-label='Normen und Richtlinien'
            className='border-y border-border bg-card/70'
        >
            <div className='mx-auto flex max-w-6xl flex-col gap-6 px-6 py-8 lg:flex-row lg:items-center lg:gap-12'>
                <p className='shrink-0 font-mono text-[0.7rem] font-medium uppercase leading-relaxed tracking-[0.18em] text-muted-foreground lg:w-44'>
                    Dokumentation mit Bezug auf
                </p>

                <ul className='grid flex-1 gap-5 sm:grid-cols-3 lg:gap-8'>
                    {STANDARDS.map((standard) => (
                        <li key={standard.name} className='flex items-start gap-3'>
                            <span className='mt-0.5 flex size-9 shrink-0 items-center justify-center rounded-xl border border-border bg-background text-primary'>
                                <FileCheck2 className='size-4' aria-hidden='true' />
                            </span>

                            <div>
                                <p className='font-medium text-foreground'>
                                    {standard.name}
                                </p>

                                <p className='mt-0.5 text-sm text-muted-foreground'>
                                    {standard.detail}
                                </p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}
